<template>
  <b-card>
    <div class="cursor-pointer row" @click.stop="toggle">
      
      <template v-if="$scopedSlots.header">
        <slot name="header" :expandido="expandido" />
      </template>

      <template v-else>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center w-100">
            <h5 class="mb-0"> </h5>
            <i :class="expandido ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'" class="icone-accordion"></i>
          </div>
        </div>
      </template>

    </div>

    <b-collapse v-model="expandido" class="mt-3">
      <hr />

      <slot />
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  props: {
    abrirAoCarregar: {
      type   : Boolean,
      default: true
    }
  },
  data() {
    return {
      expandido: this.abrirAoCarregar
    };
  },
  methods: {
    toggle() {
      this.expandido = !this.expandido;
    },
    fechar() {
      this.expandido = false;
    },
    abrir() {
      this.expandido = true;
    }
  }
};
</script>

<style scoped>
.icone-accordion {
  font-size: 24px;
}
</style>
